<script setup>
import axios from 'axios';
import { BLink, BTable } from 'bootstrap-vue-next';
import { ref } from 'vue';

import FilterCard from '~/common/components/FilterCard.vue';
import PointsDocumentationTooltip from '~/common/components/PointsDocumentationTooltip.vue';
import RoutePagination from '~/common/components/RoutePagination.vue';
import ThemedOverlay from '~/common/components/ThemedOverlay.vue';
import { numberProps } from '~/common/FieldFormats';

const organizations = ref([]);
const busy = ref(true);
const filterData = ref({
  fromDate: '',
  toDate: '',
  search: '',
  currentPage: 1,
});
const pageData = ref({
  perPage: 50,
  totalRows: 0,
});

const fields = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'contributors_count',
    label: 'Contributors',
    ...numberProps,
  },
  {
    key: 'score',
    label: 'Score',
    ...numberProps,
  },
];

const fetchData = async () => {
  busy.value = true;

  const params = {
    from_date: filterData.value.fromDate,
    to_date: filterData.value.toDate,
    search: filterData.value.search,
    page: filterData.value.currentPage,
  };
  const response = await axios.get(
    '/api/v1/organizations',
    { params },
  );
  const { records, metadata } = await response.data;
  organizations.value = records;
  pageData.value = {
    perPage: metadata.per_page,
    totalRows: metadata.total_count,
  };

  busy.value = false;
};
</script>

<template>
  <FilterCard
    v-model="filterData"
    show-search
    @filter="fetchData"
  />

  <ThemedOverlay :show="busy">
    <BTable
      :fields="fields"
      :items="organizations"
      responsive="md"
      show-empty
    >
      <template #head(score)="{ field: { label } }">
        <div class="d-inline-flex">
          {{ label }}
          <PointsDocumentationTooltip />
        </div>
      </template>
      <template #cell(name)="{ value }">
        <BLink
          :to="{
            name: 'organization',
            params: { organizationName: value },
            query: { fromDate: filterData.fromDate, toDate: filterData.toDate }
          }"
        >
          {{ value }}
        </BLink>
      </template>
    </BTable>
    <RoutePagination
      v-model="filterData.currentPage"
      :total-rows="pageData.totalRows"
      :per-page="pageData.perPage"
    />
  </ThemedOverlay>
</template>
